import { CommandRequestType } from '../../authentication/connection/commandRequestType';
import { ICommandParameters } from '../../authentication/connection/iCommandParameters';
import { ICommandResponse } from '../../authentication/connection/iCommandResponse';
import { ErrorDetails } from '../../authentication/connection/interfaces/apiInterfaces';
import { IRequestCommand } from '../../authentication/connection/iRequestCommand';

export class GetCountContractorsCommand extends IRequestCommand<
  IGetCountContractorsResponse,
  ErrorDetails,
  IGetCountContractorsParameters
> {
  override _commandType: CommandRequestType = CommandRequestType.GET;
  // NOTE: singular /carrier/ (not /carriers/) per API spec
  override _commandUrl = 'carrier/{carrierUserId}/contractors/totals';

  public override setParameters(parameters: IGetCountContractorsParameters) {
    this._commandUrl = this._commandUrl.replace(
      '{carrierUserId}',
      parameters.carrierUserId
    );
  }
}

export interface IGetCountContractorsParameters extends ICommandParameters {
  carrierUserId: string;
}

export interface IGetCountContractorsResponse extends ICommandResponse {
  countLocal: number;
  countACCECAR: number;
}
